const OrderStatusBadge = ({ status }) => {
  switch (status) {
    case "scheduled":
      return <div className="badge bg-warning text-white">Scheduled</div>;
    case "0":
      return <div className="badge bg-silver text-dark">Pending</div>;
    case "1":
      return <div className="badge bg-dark-grey text-light">Pickup</div>;
    case "2":
      return <div className="badge bg-primary text-light">Arrived</div>;
    case "3":
    case "4":
      return <div className="badge text-white bg-info">Scanned</div>;
    case "5":
      return <div className="badge bg-success text-light">En Route</div>;
    case "6":
      return <div className="badge bg-success text-light">Completed</div>;
    case "-1":
      return <div className="badge text-white bg-danger">Failed</div>;
    case "-2":
      return <div className="badge text-white bg-danger">Cancelled</div>;
    case "-3":
      return <div className="badge text-white bg-danger">Archieved</div>;
    default:
      return <div>{status}</div>;
  }
};

export default OrderStatusBadge;
